import { useMemo, type ReactNode } from 'react';

import type { FormAttachment, Form, FormsOptions, TemplateType } from 'types';

import { FormEditContext } from './FormEditContext';

type Props = {
  form: Form;
  attachments: FormAttachment[];
  refetchAttachment: () => Promise<unknown>;
  formsOptions: FormsOptions;
  children: ReactNode;
  template?: TemplateType;
};

export const FormEditContextProvider = ({
  form,
  attachments,
  refetchAttachment,
  formsOptions,
  children,
  template,
}: Props) => {
  const value = useMemo(
    () => ({ form, attachments, formsOptions, template, refetchAttachment }),
    [form, attachments, formsOptions, template],
  );

  return (
    <FormEditContext.Provider value={value}>
      {children}
    </FormEditContext.Provider>
  );
};
